import { css } from 'linaria';

export const MenuClassName = css`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: var(--space-300);
  padding: var(--space-200) 0 var(--space-275);
  overflow: hidden;

  @media (hover: none) and (pointer: coarse) {
    overflow: visible;
    overflow-y: scroll;
  }
`;

export const ItemClassName = css`
  text-wrap: nowrap;

  &[data-testid='button']:hover {
    background-color: unset !important;
    box-shadow: none !important;
    color: var(--brand-dark) !important;
  }

  > img {
    margin-right: var(--space-100);
  }
`;

export const ShadowBackgroundClassName = css`
  height: var(--space-300);
  background: linear-gradient(180deg, rgba(70, 76, 92, 0.04) 0%, rgba(255, 255, 255, 0) 100%);
`;
